import { useEffect, useState } from 'react';
import { Credit } from '@types';
import { AntdDateInput, InitialCard, InitialRow } from '@components';
import { checkSuperadmin } from '@providers';
import { AREAS, rbac } from '@utils';

const hasPermissionAreas = [AREAS.FINANCE, AREAS.LEGAL];

interface Props {
    credit: Credit;
    editable: boolean;
}

export const CreditDates = ({ credit, editable }: Props) => {
  const isSuperadmin = checkSuperadmin();
  const [isDatesDisabled, setIsDatesDisabled] = useState(!editable);

  useEffect(() => {
    const hasPermissions = hasPermissionAreas.some(area => rbac.hasArea(area));
    const canEdit = editable && (isSuperadmin || hasPermissions);

    setIsDatesDisabled(!canEdit);

  }, [editable, isSuperadmin]);

  return (
    <InitialCard
      left="Disbursement data"
      autoHeight
      extraPadding
    >
      <div>
        <InitialRow title="Signature of Contract:">
          <AntdDateInput
            label=""
            source="signedContractAt"
            style={{ width: 80 }}
            disabled={isDatesDisabled}
            hideHelperText={true}
          />
        </InitialRow>
        <InitialRow title="Disbursement Date:">
          <AntdDateInput
            label=""
            source="signatureAt"
            style={{ width: 80 }}
            disabled={isDatesDisabled}
            hideHelperText={true}
          />
        </InitialRow>
        <InitialRow title="Payment at:">
          <AntdDateInput
            label=""
            source="paymentAt"
            style={{ width: 80 }}
            disabled={isDatesDisabled}
            hideHelperText={true}
          />
        </InitialRow>
      </div>
    </InitialCard>
  );
};
